export class EventListener{
    static addEventListener(element:HTMLElement,eventType:string,handler:any):void{
        return element.addEventListener(eventType,handler);
    }
}



// WEBPACK FOOTER //
// ./src/extend/EventListener.ts